export const replaceSpaces = (category: string) => category.replace(/\s/g, '-');

export const replaceDashes = (category: string) => category.replace(/-/g, ' ');